"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _WalletCardComponent = _interopRequireDefault(require("./WalletCardComponent"));
var _productPositionSelectors = require("../../redux/selectors/productPositionSelectors");
var _baseCurrenciesSelectors = require("../../redux/selectors/baseCurrenciesSelectors");
var _positionActions = require("../../redux/actions/positionActions");
var _config = _interopRequireDefault(require("../../config"));
var _get = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _getProductByIdSelect = (0, _productPositionSelectors.getProductByIdSelector)(state, ownProps.productId),
    iconFileName = _getProductByIdSelect.iconFileName,
    ProductSymbol = _getProductByIdSelect.ProductSymbol,
    ProductFullName = _getProductByIdSelect.ProductFullName,
    Amount = _getProductByIdSelect.Amount,
    rawAmount = _getProductByIdSelect.rawAmount,
    ProductType = _getProductByIdSelect.ProductType,
    ProductId = _getProductByIdSelect.ProductId,
    productColor = _getProductByIdSelect.productColor,
    NotionalValue = _getProductByIdSelect.NotionalValue,
    NotionalProductSymbol = _getProductByIdSelect.NotionalProductSymbol,
    isDepositAllowed = _getProductByIdSelect.DepositEnabled,
    isWithdrawAllowed = _getProductByIdSelect.WithdrawEnabled;
  var baseCurrency = (0, _baseCurrenciesSelectors.baseCurrencyPriceSelector)(state, ownProps.productId);
  var isCrypto = ProductType === 'CryptoCurrency';
  var showNotionalValue = NotionalValue && NotionalProductSymbol && (0, _get["default"])(_config["default"], 'Wallets.showNotionalValue', false);
  return {
    iconFileName: iconFileName,
    ProductSymbol: ProductSymbol,
    ProductFullName: ProductFullName,
    Amount: Amount,
    rawAmount: rawAmount,
    isCrypto: isCrypto,
    ProductId: ProductId,
    productColor: productColor,
    baseCurrency: baseCurrency,
    NotionalValue: NotionalValue,
    NotionalProductSymbol: NotionalProductSymbol,
    isWithdrawAllowed: isWithdrawAllowed,
    isDepositAllowed: isDepositAllowed,
    showNotionalValue: showNotionalValue,
    detailsLink: ownProps.detailsLink
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    selectPositionAndSave: function selectPositionAndSave() {
      dispatch((0, _positionActions.selectPositionAndSave)(ownProps.productId));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_WalletCardComponent["default"]);